module.exports = function(h, row) {
    if (_.isNull(row.outlet)) {
        return <i>{this.trans('product.visible_to_all_outlets')}</i>;
    }

    return row.outlet;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/item/vuetableitem_outlet.jsx